module.exports = __webpack_public_path__ + "static/atlaskit-table-highlight-c873d9f9293f113da322ab56699277ed.png";